import { lazy } from "react";

import Config from "./Config";

const PodcastsTips = {
  key: "podcasts.tips",
  Renderer: lazy(() => import("./Renderer")),
  Inspector: lazy(() => import("./Inspector")),
  Config,
};

export default PodcastsTips;
